import * as React from 'react';
import { useTranslation } from 'react-i18next';

// `message` is optional and arrives already translated; without it the
// generic text is shown, as before.
export default ({ message }) => {
  const { t } = useTranslation();

  return <div className="alert alert-info text-center">{message || t('No records found')}</div>;
};
